module.exports = __webpack_public_path__ + "img/34.9e5317fd.jpg";